import React, { useState } from "react";
import { IconButton, Popover } from "@mui/material";
import { EllipsisIcon } from "../../../../assets/icons";

interface Props {
  RequestElement: JSX.Element;
  RemindElement: JSX.Element;
  CancelRequestElement: JSX.Element;
}
interface State {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
}
const TnAActions = ({ RequestElement, RemindElement, CancelRequestElement }: Props) => {
  const [state, setState] = useState<State>({
    open: false,
    anchorEl: null,
  });
  return (
    <>
      <IconButton
        onClick={(event) => {
          setState((state) => ({
            ...state,
            open: true,
            anchorEl: event.currentTarget as HTMLButtonElement,
          }));
        }}
      >
        <EllipsisIcon />
      </IconButton>
      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={() => {
          setState((state) => ({ ...state, open: false }));
        }}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            backgroundColor: "rgb(245, 245, 245)",
            alignItems: "flex-start",
            gap: "5px",
          },
        }}
      >
        {RequestElement}
        {RemindElement}
        {CancelRequestElement}
      </Popover>
    </>
  );
};
export default TnAActions;
